<script setup>
const props = defineProps({
  contentType: {
    type: String,
    default: 'Video',
  },
  tags: {
    type: Array,
    default: () => [],
  },
});

const routeName = computed(() => {
  return props.contentType === 'Video' ? 'discover' : 'live';
});
</script>

<template>
  <ul class="no-scrollbar z-[1] flex gap-2 overflow-y-hidden overflow-x-scroll">
    <template v-if="tags.length">
      <li
        v-for="item in tags"
        :key="item.value"
        class="h-fit cursor-pointer select-none whitespace-nowrap rounded-full border border-blue-400 px-4 py-1 text-sm text-blue-400 dark:border-transparent dark:bg-white/20 dark:text-white"
      >
        <NuxtLink
          :to="{
            name: routeName,
            query: {
              [item.type]: item.type === 'tag' ? item.value : item.tagId,
            },
          }"
        >
          {{ item.value }}
        </NuxtLink>
      </li>
    </template>
  </ul>
</template>
